import { Modal } from "antd";
import React, { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { DEFAULT_PAGE_SIZE } from "../../../../app/constants";
import { RootState } from "../../../../app/reducer";
import { getCustomerReferralList } from "../../../../services/referrals";
import { setReferralsState } from "../../../../slices/referrals";
import ReferralModalFilterBar from "./filter";
import ModalPagination from "./pagination";
import ModalTable from "./table";

const selector = (state: RootState) => ({
    transactions: state?.referrals?.customerReferrals,
    paging: state?.referrals?.customerReferralsPaging,
    searchConditions: state?.referrals?.customerReferralsSearchConditions,
});

function CustomerReferrals(): JSX.Element {
    const dispatch = useDispatch();
    const { transactions, searchConditions } = useSelector(selector);

    const onClose = () => {
        dispatch(
            setReferralsState({
                customerReferrals: [],
                customerReferralsPaging: {},
                customerReferralsSearchConditions: {
                    page: 1,
                    limit: DEFAULT_PAGE_SIZE,
                },
            })
        );
    };

    useEffect(() => {
        if (searchConditions?.ref_code) {
            dispatch(getCustomerReferralList(searchConditions));
        }
    }, [searchConditions, dispatch]);

    return (
        <Modal
            title={<FormattedMessage id="customer_referrals" />}
            visible={(transactions?.length ?? 0) > 0}
            onCancel={onClose}
            width={900}
            footer={null}
        >
            <div className="points-history-table">
                <ReferralModalFilterBar />
                <ModalTable />
                <ModalPagination />
            </div>
        </Modal>
    );
}

export default CustomerReferrals;
